import { render, staticRenderFns } from "./delivery-form.vue?vue&type=template&id=5675ec08"
import script from "./delivery-form.vue?vue&type=script&lang=js"
export * from "./delivery-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsFormSelect: require('/home/node/app/components/patterns/form-select/form-select.vue').default,PatternsFormInput: require('/home/node/app/components/patterns/form-input/form-input.vue').default,ElementsFormErrorMessage: require('/home/node/app/components/elements/form-error-message/form-error-message.vue').default,PatternsFormGroup: require('/home/node/app/components/patterns/form-group/form-group.vue').default,ElementsCustomerBlock: require('/home/node/app/components/elements/customer-block/customer-block.vue').default})
